var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M46.647 38.799A2.466 2.466 0 0 1 44.505 40H2.473c-.893 0-1.693-.45-2.14-1.201a2.314 2.314 0 0 1 .005-2.403L21.353 1.194A2.46 2.46 0 0 1 23.49 0c.891 0 1.689.446 2.136 1.194l21.017 35.202c.447.752.449 1.649.004 2.403zm-1.429-1.6L24.202 1.997a.816.816 0 0 0-.712-.397.81.81 0 0 0-.713.397L1.761 37.199a.767.767 0 0 0-.001.8.811.811 0 0 0 .713.402h42.032a.813.813 0 0 0 .714-.402.765.765 0 0 0-.001-.8zm-23.376-5.197h1.648v1.6h-1.648v-1.6zm0-18.395h1.648v15.996h-1.648V13.607z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b6999926f70695ee09dcf3df2c3d83c8.svg";
export { ForwardRef as ReactComponent };